import OrderButtons from '../OrderButtons/order-buttons';

export default OrderButtons;